<template>
	<Modal
		class="parallel-view-modal"
		:title="title"
		:closeable="false"
		:blocking="true"
	>
		<!-- body -->
		<template #body>
			<div>
				{{ $I18n.trans('view_mode.parallel_views.message') }}
			</div>
			<div
				v-if="parallelView"
				class="parallel-view-modal__device"
			>
				<strong v-if="parallelView.client">
					{{ parallelView.client }}
				</strong>
				<strong v-else>
					{{ $I18n.trans('view_mode.parallel_views.unknown_device') }}
				</strong>

				<p v-if="parallelView.location">
					{{ $I18n.trans('view_mode.parallel_views.location') }}: {{ parallelView.location }}
				</p>
				<p v-else>
					{{ $I18n.trans('view_mode.parallel_views.unknown_location') }}
				</p>
			</div>
			<div>
				{{ $I18n.trans('view_mode.parallel_views.hint') }}
			</div>
		</template>
		<!-- footer -->
		<template #footer-buttons>
			<button
				class="button button--primary"
				:disabled="timeout > 0"
				@click="reload"
			>
				<span>{{ buttonLabel }}</span>
			</button>
		</template>
	</Modal>
</template>

<script>
import Modal from '../modal';

export default {
	name:       'ParallelViewModal',
	components: { Modal },
	props:      {
		parallelView: {
			type:    Object,
			default: () => null,
		},
	},
	data() {
		return {
			title:           this.$I18n.trans('view_mode.parallel_views.title'),
			timeout:         null,
			buttonLabel:     null,
			timeoutInterval: null,
		};
	},
	computed: {

	},
	mounted() {
		this.timeout = 30;
		this.timeoutInterval = setInterval(() => {
			if (this.timeout <= 0) {
				clearInterval(this.timeoutInterval);
				this.timeoutInterval = null;
				return;
			}

			this.timeout = this.timeout - 1;
			this.timeout--;
			this.setBtnLabel();
		}, 1000);
	},
	methods: {
		setBtnLabel() {
			this.buttonLabel = this.timeout > 0 ? this.$I18n.trans('view_mode.parallel_views.button_timeout', { seconds: this.timeout }) : this.$I18n.trans('view_mode.parallel_views.button');
		},
		reload() {
			window.location.reload();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.parallel-view-modal__device {
	margin: 24px 0;
	border: 1px solid var(--color-grey-750);
	background-color: var(--color-grey-950);
	padding: 16px;
}
</style>
